export default __webpack_public_path__ + "static/media/linkedin (2).b57ac1fe.png";